import template from './static.html';
import './static.global.css';

export const AddressStaticComponent = {
  bindings: {
    address: '<',
    editable: '<',
    click: '&',
  },
  template,
};
